import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID || "04jo9zbm",
  dataset: process.env.REACT_APP_SANITY_DATASET || "production",
  apiVersion: process.env.REACT_APP_SANITY_API_VERSION || "2024-12-25",
  useCdn: true,
});
